$(document).ready(function() {

  // radio button selection
  $('label.card-radio').click(function(e){
    $(this).find('input[name=service-type]').prop('checked', true);
    e.stopPropagation();
    e.preventDefault();
  });

  // process the form  
  $('form').submit(function(event) {
    // get the form data
    var form = $(this);
    var data = form.serializeArray();

    form.validate();

    if(form.valid()){    
      // process the form
      $.ajax({
        type: 'POST', // define the type of HTTP verb we want to use (POST for our form)
        url: 'https://trident.kayo.dev/api/submitForm', // the url where we want to POST
        contentType: 'application/json; charset=utf-8',
        dataType : 'json',
        data : JSON.stringify(getFormData(data)),
        dataType: 'json', // what type of data do we expect back from the server
        encode: true,
        beforeSend: function() {
          $("#js-form-submit").attr("disabled", true);
          $("#js-form-submit").html('Sending...')
        },
        success : function(response) {
          $('#js-form-rollup').slideUp(600,function(){
            let headerHeight = $('.header').outerHeight();
            let navHeight =	$('nav').outerHeight();
            let scrollHeight = headerHeight + navHeight
            $("#js-form-submit").html('Sent!')
            $('html, body').animate({
              scrollTop: ($('#js-form-title').offset().top - scrollHeight)
            },500);
            $('div#js-form-submit-message').html(response.successMessage);
            gtag('event', 'conversion', {'send_to': 'AW-318106161/OSwgCNinnvMCELHU15cB'});
          });

        },
        error: function(xhr, resp, text) {
          console.log(xhr, resp, text);
        }
      })
    }

    event.preventDefault();
  });

  //utility function
  function getFormData(data) {
    var unindexed_array = data;
    var indexed_array = {};

    $.map(unindexed_array, function(n, i) {
      indexed_array[n['name']] = n['value'];
    });

    return indexed_array;
  }

});